import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { View } from '@uncinc/react-drupal-core';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import type { TargetAudienceProps } from '..';
import {
  DynamicMediaItem,
  Hero,
  ParagraphsRenderer,
  RelatedContentByTargetAudience,
} from '../../../../../components';

const TaxonomyTargetAudiencePageChild: React.FC<TargetAudienceProps> = ({ entity }) => {
  const { t } = useTranslation('translation', { keyPrefix: 'pages.taxonomy_target_audience_page' });

  const targetAudience = entity.toJS();
  const name = targetAudience.name[0].value;
  const id = targetAudience.tid[0].value;
  const paragraphs = targetAudience.field_paragraphs;

  const classes = c('TaxonomyTargetAudiencePage', 'TaxonomyTargetAudiencePage--Child');

  return (
    <div className={classes}>
      <Hero
        title={name}
        body={targetAudience.field_description_with_summary[0]?.processed || ''}
        media={<DynamicMediaItem media={targetAudience.field_media_item[0]} imageAspectRatio="4_3" aboveTheFold />}
        containMedia={targetAudience.field_media_item[0].bundle === 'svg'}
        background="primary"
      />

      <Container>
        <div className="content-section">
          <div className="row">
            {paragraphs.length > 0 && (
              <div className="col-md-7 mb-12 mb-md-0">
                <ParagraphsRenderer paragraphs={paragraphs} />
              </div>
            )}

            <div className="col-md-5">
              <View
                key={`docs_by_target_audience:${id}`}
                id="docs"
                display="docs_by_target_audience"
                args={[id, 'document']}
                resetStateOnUnmount
              />
            </div>
          </div>
        </div>
      </Container>

      <RelatedContentByTargetAudience
        contentType="event"
        targetAudienceId={id}
        targetAudienceName={name}
        title={t('related_events_title', { targetAudience: name.toLowerCase() })}
      />

      <RelatedContentByTargetAudience
        contentType="article"
        targetAudienceId={id}
        targetAudienceName={name}
        title={t('related_articles_title', { targetAudience: name.toLowerCase() })}
        className="mt-0"
      />
    </div>
  );
};

export default TaxonomyTargetAudiencePageChild;
